import React from 'react';
import get from "lodash/get";
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import DayPicker from 'react-day-picker';
import MomentLocaleUtils from 'react-day-picker/moment';
import 'moment/min/locales';
import moment from 'moment';


class DateInputComponent extends React.Component {
  constructor (props) {
    super(props);

    this.dayClick = this.dayClick.bind(this);
  }

  dayClick (date, modifiers = {}) {
    if (modifiers.disabled) return;
    const { onDayClick, validFn } = this.props;
    onDayClick(date);
    validFn();
  }


  render () {
    const { inputRef, selectedDate, hasError, errorMessage, country, intl } = this.props;
    return (
      <div>
        <DayPicker
          fromMonth={new Date()}
          onDayClick={this.dayClick}
          className="availability-calendar"
          month={selectedDate}
          localeUtils={MomentLocaleUtils}
          selectedDays={selectedDate}
          disabledDays={[{ before: new Date() }]}
          locale={get(intl, 'locale', 'en')}
        />

        <input
          ref={ ref => {
            if ('function' === typeof inputRef) inputRef(ref);
          }
          }
          type="hidden"
          readOnly
          data-value={selectedDate}
          value={selectedDate ? moment(selectedDate).format('ll') : ''}
        />
        {
          hasError && <div style={{ marginBottom: '16px' }} className="text-danger help-block">{errorMessage}</div>
        }
      </div>
    );
  }
}

DateInputComponent.propTypes = {
  inputRef: PropTypes.func,
  onDayClick: PropTypes.func.isRequired,
  selectedDate: PropTypes.instanceOf(Date),
  hasError: PropTypes.bool,
  validFn: PropTypes.func,
  errorMessage: PropTypes.string,
  country: PropTypes.string
};

export const DateInput = injectIntl(DateInputComponent);